export default () => ({
  endOfLifeCategories: {},
  endOfLifeCategorySlugsToIds: {},
  endOfLifeCategoryTree: [],
  endOfLifeCategoryItemCounts: {},
});
